import React, { Component } from 'react';
import { SafeAreaView } from 'react-native';
import { Audio, Video } from 'expo-av';
import { activateKeepAwake, deactivateKeepAwake } from 'expo-keep-awake';
import { ActivityIndicator, View, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import Theme from '../../theme'
import { Icon } from '../../components';
import { UserServiceClient } from 'fitbeat.api-clients';
import { getApiConfig } from '../../config/index';
import { AuthTokenBuilder, Logger } from '../../utils';
import { VideoPlayer } from './video/videoPlayer';

class VideoDisplay extends Component {
  authenticatedUserServiceClient = new UserServiceClient(getApiConfig(), fetch, console.log, new AuthTokenBuilder());
  constructor(props) {
    super(props);

    this.state = {
      videoUrl: null,
      isLoading: false,
    };
  }

  async componentDidMount() {
    activateKeepAwake();
    const { videoName, videoSource } = this.props;

    if (Platform.OS !== 'web') {
      await Audio.setAudioModeAsync({
        playsInSilentModeIOS: true,
        playThroughEarpieceAndroid: false,
      });
    }

    if (videoName) {
      await this.loadVideoFromCdn(videoName);
      const videoSource = await this.authenticatedUserServiceClient.getVideoUrlFor(videoName);
      this.setState({ source: {uri: videoSource.videoUrl }});
    }

    if (videoSource) {
      await this.loadVideoFromSource(videoSource);
      this.setState({ source: videoSource });
    }
  }

  async componentWillUnmount() {
    deactivateKeepAwake();
  }

  async componentDidUpdate(prevProps) {
    if (this.props.videoName !== prevProps.videoName) {
      this.loadVideoFromCdn(this.props.videoName);
      const videoSource = await this.authenticatedUserServiceClient.getVideoUrlFor(this.props.videoName);
      this.setState({ videoUrl: videoSource.videoUrl });
    }

    if (this.props.videoSource !== prevProps.videoSource) {
      this.loadVideoFromSource(this.props.videoSource);
      const videoSource = this.props.videoSource;
      this.setState({ videoUrl: videoSource.uri });
    }
  }

  async loadVideoFromCdn(videoName) {
    if (!this._video) {
      return;
    }

    try {
      this.setState({
        isLoading: true,
      });

      const videoRespone = await this.authenticatedUserServiceClient.getVideoUrlFor(videoName);
      this._video.loadAsync({
        uri: videoRespone.videoUrl
      }, initialState = {
        shouldPlay: true,
      }, false);
    } catch (e) {
      Logger.notify(e);
      this.setState({
        isLoading: false,
      });
    }
  }

  async loadVideoFromSource(videoSource) {
    if (!this._video) {
      return;
    }

    this.setState({
      isLoading: true,
    });

    try {
      await this._video.loadAsync(videoSource, {
        shouldPlay: true,
      }, false);

    } catch (e) {
      alert(e.message)
      Logger.notify(e);
    }
  }

  loaded = () => {
    this.setState({
      isLoading: false,
    });
  }

  videoStatusUpdate(status) {
    if (status.didJustFinish) {
      this.onEnd();
    }
  }

  onEnd = () => {
    if (Platform.OS === 'ios') {
      const majorVersionIOS = parseInt(Platform.Version, 10);
      if (majorVersionIOS >= 11) {
        this.props.closeVideo();
      }
    } else {
      this.props.closeVideo();
    }
  }

  render() {
    const {
      closeVideo,
      isVideoVisible,
      overrideVideoStyle,
      headerTopStyleOverride,
      renderCloseButton = true,
      containerStyleOverride,
      useNativeControls = true,
    } = this.props;

    const {
      isLoading,
    } = this.state;

    if (!isVideoVisible) {
      return null;
    }

    return (
      <>
        <View style={[StyleSheet.absoluteFill, styles.container, containerStyleOverride]}>
          {renderCloseButton &&
            <View style={[styles.headerTop, headerTopStyleOverride]}>
              <TouchableOpacity
                hitSlop={{
                  bottom: 5,
                  top: 5,
                  left: 5,
                  right: 5,
                }}
                style={[styles.closeContainer]}
                onPress={closeVideo}>
                <Icon
                  size={50}
                  color={Theme.GREY}
                  name='ios-close-outline'
                  onPress={closeVideo}
                />
              </TouchableOpacity>
            </View>
          }
          {isLoading &&
            <View style={styles.loadingStyle}>
              <ActivityIndicator
                size='small'
                color={Theme.PRIMARY}
                animating={true}
              />
            </View>
          }
          <VideoPlayer
            overrideVideoStyle={overrideVideoStyle} // This get passed into the web polyfill video
            videoStyle={[styles.videoStyle, overrideVideoStyle]}
            onPlaybackStatusUpdate={this.videoStatusUpdate}
            onEnd={this.onEnd}
            onLoad={this.loaded}
            resizeMode={'contain'}
            shouldPlay={true}
            source={this.state.source}
          />
        </View>
        <SafeAreaView style={{flex: 0}}/>
      </>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Theme.BLACK,
  },
  headerTop: {
    ...StyleSheet.absoluteFillObject,
    height: 45,
    zIndex: 10,
    paddingHorizontal: 15,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'transparent',
    top: Platform.OS === 'ios' ? 20 : 0,
  },
  videoStyle: {
    top: Platform.OS === 'ios' ? 20 + 45 : 45,
  },
  loadingStyle: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
  },
  closeContainer: {
    lineHeight: 45,
  }
});

export default VideoDisplay;
